import { Section } from '../components/Section';
import { Container } from '../components/Container';
import { FeatureCard } from '../components/FeatureCard';

const WidgetIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
    <line x1="8" y1="21" x2="16" y2="21" />
    <line x1="12" y1="17" x2="12" y2="21" />
  </svg>
);

const BillingIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
    <line x1="1" y1="10" x2="23" y2="10" />
  </svg>
);

const OrderIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
    <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
    <line x1="12" y1="22.08" x2="12" y2="12" />
  </svg>
);

const PortalIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const RetryIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="23 4 23 10 17 10" />
    <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
  </svg>
);

const DashboardIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="20" x2="18" y2="10" />
    <line x1="12" y1="20" x2="12" y2="4" />
    <line x1="6" y1="20" x2="6" y2="14" />
  </svg>
);

const features = [
  {
    icon: <WidgetIcon />,
    heading: 'Widget na página do produto',
    description: 'O cliente escolhe a frequência e assina direto na sua loja. Sem redirecionamentos.',
  },
  {
    icon: <BillingIcon />,
    heading: 'Cobrança automática',
    description: 'Mercado Pago cobra o cliente no ciclo certo. Você não precisa fazer nada.',
  },
  {
    icon: <OrderIcon />,
    heading: 'Pedidos criados automaticamente',
    description: 'Cada pagamento aprovado vira um pedido real na sua loja. Só despachar.',
  },
  {
    icon: <PortalIcon />,
    heading: 'Portal do assinante',
    description: 'Seu cliente pausa, pula entrega ou cancela sozinho. Menos suporte pra você.',
  },
  {
    icon: <RetryIcon />,
    heading: 'Recuperação de pagamento',
    description: 'Se o pagamento falhar, o Assine tenta recuperar automaticamente antes de cancelar.',
  },
  {
    icon: <DashboardIcon />,
    heading: 'Painel com métricas',
    description: 'MRR, assinantes ativos, churn -- tudo visível no admin da Nuvemshop.',
  },
];

export function Features() {
  return (
    <Section background="gray">
      <Container maxWidth="content">
        <h2
          style={{
            fontSize: '24px',
            fontFamily: 'var(--font-heading)',
            fontWeight: 800,
            color: '#111827',
            textAlign: 'center',
            marginBottom: 'var(--spacing-xl)',
            lineHeight: 1.2,
          }}
        >
          Tudo que você precisa para vender por assinatura
        </h2>
        <div className="features-grid">
          {features.map((feature) => (
            <FeatureCard key={feature.heading} {...feature} />
          ))}
        </div>
      </Container>
      <style>{`
        .features-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: var(--spacing-lg);
        }
        @media (max-width: 1023px) and (min-width: 640px) {
          .features-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        @media (max-width: 639px) {
          .features-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </Section>
  );
}
